/**
 * 現在の環境に基づいて、APIのURLを取得します
 * NEXT_PUBLIC_PREVIEW_KEYが設定されている場合は、その値をもとにAPIのURLを決定します
 * (https://${process.env.NEXT_PUBLIC_PREVIEW_KEY}-tourmaline-dtbopqyaia-an.a.run.app)
 * そうでない場合は、NEXT_PUBLIC_API_URLを使用します
 */
export function getApiUrl(): string {
  if (process.env.NEXT_PUBLIC_PREVIEW_KEY) {
    if (process.env.NEXT_PUBLIC_ENV === "staging") {
      return `https://${process.env.NEXT_PUBLIC_PREVIEW_KEY}-tourmaline-yoesdyxhka-an.a.run.app`;
    }
    return `https://${process.env.NEXT_PUBLIC_PREVIEW_KEY}-tourmaline-dtbopqyaia-an.a.run.app`;
  }
  if (!process.env.NEXT_PUBLIC_API_URL) {
    throw new Error("NEXT_PUBLIC_API_URL is not set");
  }
  return process.env.NEXT_PUBLIC_API_URL;
}

function getAuthApiUrl(): string {
  if (process.env.NEXT_PUBLIC_PREVIEW_KEY) {
    if (process.env.NEXT_PUBLIC_ENV === "staging") {
      return "https://stg.api.amethy.st";
    }
    return "https://dev.api.amethy.st";
  }
  return getApiUrl();
}

/**
 * Production frontend の origin です。
 * 顧客に共有できる URL は常にこの origin である必要があるため、
 * 環境判定を伴わない定数として公開します。
 */
export const PRODUCTION_FRONTEND_ORIGIN = "https://app.amethy.st";

/**
 * Staging 環境（stg.amethy.st および staging preview）かどうかを返します
 */
export function isStagingEnv(): boolean {
  return process.env.NEXT_PUBLIC_ENV === "staging";
}

export function getFrontendUrl(): string {
  if (process.env.NEXT_PUBLIC_FRONTEND_URL) {
    return process.env.NEXT_PUBLIC_FRONTEND_URL;
  }
  if (process.env.NEXT_PUBLIC_PREVIEW_KEY) {
    if (process.env.NEXT_PUBLIC_ENV === "staging") {
      return `https://${process.env.NEXT_PUBLIC_PREVIEW_KEY}-amethyst-yoesdyxhka-an.a.run.app`;
    }
    return `https://${process.env.NEXT_PUBLIC_PREVIEW_KEY}-amethyst-dtbopqyaia-an.a.run.app`;
  }
  switch (process.env.NEXT_PUBLIC_ENV) {
    case "development":
      return "https://dev.amethy.st";
    case "staging":
      return "https://stg.amethy.st";
    case "production":
      return PRODUCTION_FRONTEND_ORIGIN;
    case "demo":
      return "https://demo.amethy.st";
    default:
      throw new Error("NEXT_PUBLIC_FRONTEND_URL is not set");
  }
}

export function getAuthUrl(): string {
  const authUrl = new URL("/auth", getAuthApiUrl());
  if (process.env.NEXT_PUBLIC_PREVIEW_KEY) {
    authUrl.searchParams.set(
      "redirect_url",
      `${getFrontendUrl()}/login/callback`,
    );
  }
  return authUrl.toString();
}

/**
 * Demoモードであるかどうかを返します
 * NEXT_PUBLIC_ENVがdemoの場合はtrue、それ以外の場合はfalseを返します
 */
export const isDemoMode = process.env.NEXT_PUBLIC_ENV === "demo";

/**
 * 環境に基づいて、アイコンのパスを取得します
 * NEXT_PUBLIC_ENVの値に応じて、対応するアイコンパスを返します
 */
export function getIconPath(): string {
  const env = process.env.NEXT_PUBLIC_ENV || "local";
  switch (env) {
    case "development":
      return "/amethyst-dev.svg";
    case "staging":
      return "/amethyst-stg.svg";
    case "demo":
      return "/amethyst-demo.svg";
    case "production":
      return "/amethyst-prod.svg";
    case "local":
    default:
      return "/amethyst-local.svg";
  }
}
